import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const MainLayout = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const isEntryPassPage = location.pathname === '/entry-pass';
    
    const [sidebarOpen, setSidebarOpen] = useState(() => {
        if (isMobile) return false;
        if (isEntryPassPage) return false;
        return true;
    });

    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false);
        } else if (!isEntryPassPage) {
            setSidebarOpen(true);
        }
    }, [isMobile, isEntryPassPage]);

    // Scroll to top when location changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <Box sx={{ display: 'flex' }}>
            <Header 
                sidebarOpen={sidebarOpen} 
                onMenuClick={() => setSidebarOpen(!sidebarOpen)} 
            />
            <Sidebar 
                open={sidebarOpen} 
                onClose={() => setSidebarOpen(false)}
                variant={isMobile ? "temporary" : "persistent"}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: '100%', md: `calc(100% - ${sidebarOpen ? '240px' : '0px'})` },
                    transition: theme.transitions.create(['width', 'margin'], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    })
                }}
            >
                <Box
                    sx={{
                        p: { xs: 2, sm: 3 },
                        mt: { xs: 7, sm: 8 },
                        backgroundColor: '#f5f5f5',
                        flexGrow: 1
                    }}
                >
                    {children}
                </Box>
                {!isEntryPassPage && <Footer />}
            </Box>
        </Box>
    );
};

export default MainLayout; 